"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _cccisdFormik = require("cccisd-formik");
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _index = require("../../index.js");
var _BookmarkFields = _interopRequireDefault(require("./BookmarkFields"));
var _LinkFields = _interopRequireDefault(require("./LinkFields"));
var _ResourceFields = _interopRequireDefault(require("./ResourceFields"));
var _WysiwygFields = _interopRequireDefault(require("./WysiwygFields"));
var _TopLevelEntityTable = _interopRequireDefault(require("./TopLevelEntityTable"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PinnedContentForm = function PinnedContentForm(props) {
  var assignmentData = props.assignmentData,
    closeModal = props.closeModal,
    topLevelFormikBag = props.formikBag,
    isEdit = props.isEdit,
    editIndex = props.editIndex,
    surveyHandle = props.surveyHandle;

  // ensure number for array operations
  var moduleIndex = Number.isNaN(parseInt(props.moduleIndex, 10)) ? null : parseInt(props.moduleIndex, 10);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAdvancedExpanded = _useState2[0],
    setIsAdvancedExpanded = _useState2[1];
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []) || [];
  var isEnglish = buildLanguages.includes('en');
  var isSpanish = buildLanguages.includes('es');
  var prefix = (0, _get2["default"])(topLevelFormikBag, 'values.currentPrefix', '');
  if (!prefix) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-danger"
    }, "Error: Could not add pinned content at this time.");
  }
  function handleUpdate(vals) {
    var index = parseInt(editIndex, 10);
    if (Number.isNaN(index)) {
      return;
    }
    var fullPath = "values.".concat(prefix, ".pinnedContent");
    if (surveyHandle && (moduleIndex || moduleIndex === 0)) {
      fullPath += ".".concat(moduleIndex, ".").concat(surveyHandle);
    } else if (moduleIndex || moduleIndex === 0) {
      fullPath += ".".concat(moduleIndex, ".topLevel");
    } else {
      fullPath += '.topLevel';
    }
    var existing = (0, _get2["default"])(topLevelFormikBag, fullPath, []) || [];
    var updated = (0, _cloneDeep2["default"])(existing);
    updated[index] = vals;
    topLevelFormikBag.setFieldValue(fullPath.replace(/^values\./, ''), updated);
    topLevelFormikBag.setFieldTouched('pinnedTouched', true);
    closeModal();
  }
  function handleSave(vals) {
    var existing = (0, _get2["default"])(topLevelFormikBag, "values.".concat(prefix, ".pinnedContent"), {}) || {};
    var updated = (0, _cloneDeep2["default"])(existing);
    if (surveyHandle && (moduleIndex || moduleIndex === 0) && Array.isArray(updated[moduleIndex][surveyHandle])) {
      updated[moduleIndex][surveyHandle].push(vals);
    } else if ((moduleIndex || moduleIndex === 0) && Array.isArray(updated[moduleIndex].topLevel)) {
      updated[moduleIndex].topLevel.push(vals);
    } else if (Array.isArray(updated.topLevel)) {
      updated.topLevel.push(vals);
    }
    topLevelFormikBag.setFieldValue("".concat(prefix, ".pinnedContent"), updated);
    topLevelFormikBag.setFieldTouched('pinnedTouched', true);
    closeModal();
  }
  function validate(vals) {
    var errs = {};
    if (!vals.type || !Object.keys(_index.pinnedContentTypeOptions).includes(vals.type)) {
      errs.type = 'Required';
    }
    if (vals.visibility !== 'always') {
      if (!vals.unlockAfter || vals.unlockAfter === 'placeholder') {
        errs.unlockAfter = 'Required since Visibility is set to unlock';
      }
      if (vals.unlockAfter === 'entity' && isEnglish && !vals.entityIdEn) {
        errs.entityIdEn = 'Required';
      }
      if (vals.unlockAfter === 'entity' && isSpanish && !vals.entityIdEs) {
        errs.entityIdEs = 'Required';
      }
    }
    if (vals.type !== 'bookmark' && !isAdvancedExpanded && (errs.unlockAfter || errs.entityIdEn || errs.entityIdEs)) {
      setIsAdvancedExpanded(true);
    }

    // Link
    if (vals.type === 'link') {
      if (!vals.url) {
        errs.url = 'Required';
      } else if (!/^https:\/\/[a-zA-Z0-9]{1,}\.[^\s./]{1,}/.test(vals.url)) {
        errs.url = 'Improperly formatted; Must start with https://';
      }
    }

    // Resource
    if (vals.type === 'resource') {
      if (!vals.resourceId) {
        errs.resourceId = 'Required';
      }
      if (!vals.thumbnail) {
        if (isEnglish && !vals.headingEn) {
          errs.thumbnail = 'Must have either Thumbnail or Heading';
          errs.headingEn = 'Must have either Thumbnail or Heading';
        }
        if (isSpanish && !vals.headingEs) {
          errs.thumbnail = 'Must have either Thumbnail or Heading';
          errs.headingEs = 'Must have either Thumbnail or Heading';
        }
      }
    }

    // WYSIWYG
    if (vals.type === 'wysiwyg') {
      if (isEnglish && !vals.headingEn && !vals.contentEn) {
        errs.headingEn = 'Must have either Heading or Content';
        errs.contentEn = 'Must have either Heading or Content';
      }
      if (isSpanish && !vals.headingEs && !vals.contentEs) {
        errs.headingEs = 'Must have either Heading or Content';
        errs.contentEs = 'Must have either Heading or Content';
      }
      if (vals.visibility !== 'always' && (!vals.unlockAfter || vals.unlockAfter === 'placeholder')) {
        errs.unlockAfter = 'Must choose when this content unlocks';
      }
    }
    return errs;
  }
  var initialValues = isEdit ? props.initialValues : {
    type: 'placeholder',
    visibility: 'always',
    unlockAfter: 'placeholder'
  };
  function renderVisibilityField(subFormikBag) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      hideAlways = _ref.hideAlways;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _get2["default"])(subFormikBag || {}, 'values.visibility') === 'placeholder' ? _style["default"].placeholderSelected : ''
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "visibility",
      component: _cccisdFormik.CccisdSelect,
      label: "Visibility",
      options: [].concat(_toConsumableArray(hideAlways ? [] : [{
        value: 'always',
        label: 'Always visible and clickable'
      }]), [{
        value: 'disabled',
        label: 'Disabled until unlocked'
      }, {
        value: 'hidden',
        label: 'Hidden until unlocked'
      }])
    }));
  }
  function renderUnlockAfterField(subFormikBag) {
    // If it's always visible, no need to show "Unlock After" setting
    if (!['disabled', 'hidden'].includes((0, _get2["default"])(subFormikBag, 'values.visibility', false))) {
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    var options = [];
    var allModules = (0, _get2["default"])(topLevelFormikBag, "values.".concat(prefix, ".modules"), []) || [];
    allModules.forEach(function (mod) {
      options.push({
        value: "module_".concat(mod.id),
        label: "Completion of Module ".concat(mod.id)
      });
      mod.surveyHandles.forEach(function (sHandle, i) {
        options.push({
          value: "survey_".concat(sHandle),
          label: "Completion of Module ".concat(mod.id, " Lesson ").concat(i + 1)
        });
      });
    });
    options.unshift({
      value: 'all',
      label: 'Completion of all modules and lessons'
    });
    options.unshift({
      value: 'allRequired',
      label: 'Completion of all required modules and lessons'
    });
    options.unshift({
      value: 'entity',
      label: 'Completion of specific part of a lesson'
    });
    options.unshift({
      value: 'placeholder',
      label: '-- Select unlock rule --',
      disabled: true
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _get2["default"])(subFormikBag, 'values.unlockAfter') === 'placeholder' ? _style["default"].placeholderSelected : ''
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "unlockAfter",
      component: _cccisdFormik.CccisdSelect,
      label: "Unlock After",
      options: options
    }));
  }
  function renderAdvancedOptions(subFormikBag) {
    var _subFormikBag$values, _subFormikBag$values2;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].advancedOptions
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return setIsAdvancedExpanded(function (prev) {
          return !prev;
        });
      },
      className: 'btn btn-link ' + _style["default"].toggle,
      type: "button"
    }, isAdvancedExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "Advanced Options")), isAdvancedExpanded && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fields
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-lg-6"
    }, renderVisibilityField(subFormikBag, {
      hideAlways: false
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-lg-6"
    }, renderUnlockAfterField(subFormikBag))), (subFormikBag === null || subFormikBag === void 0 ? void 0 : (_subFormikBag$values = subFormikBag.values) === null || _subFormikBag$values === void 0 ? void 0 : _subFormikBag$values.visibility) !== 'always' && (subFormikBag === null || subFormikBag === void 0 ? void 0 : (_subFormikBag$values2 = subFormikBag.values) === null || _subFormikBag$values2 === void 0 ? void 0 : _subFormikBag$values2.unlockAfter) === 'entity' && /*#__PURE__*/_react["default"].createElement(_TopLevelEntityTable["default"], {
      assignmentData: assignmentData,
      label: "Which specific part of a Lesson?",
      subFormikBag: subFormikBag
    })));
  }
  function renderBookmarkFields(subFormikBag) {
    return /*#__PURE__*/_react["default"].createElement(_BookmarkFields["default"], {
      assignmentData: assignmentData,
      isEnglish: isEnglish,
      isSpanish: isSpanish,
      renderVisibilityField: renderVisibilityField,
      subFormikBag: subFormikBag
    });
  }
  function renderLinkFields(subFormikBag) {
    return /*#__PURE__*/_react["default"].createElement(_LinkFields["default"], {
      isEnglish: isEnglish,
      isSpanish: isSpanish,
      renderAdvancedOptions: renderAdvancedOptions,
      subFormikBag: subFormikBag
    });
  }
  function renderResourceFields(subFormikBag) {
    return /*#__PURE__*/_react["default"].createElement(_ResourceFields["default"], {
      subFormikBag: subFormikBag,
      isEnglish: isEnglish,
      isSpanish: isSpanish,
      renderAdvancedOptions: renderAdvancedOptions
    });
  }
  function renderWysiwygFields(subFormikBag) {
    return /*#__PURE__*/_react["default"].createElement(_WysiwygFields["default"], {
      isEnglish: isEnglish,
      isSpanish: isSpanish,
      renderAdvancedOptions: renderAdvancedOptions,
      subFormikBag: subFormikBag
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: isEdit ? handleUpdate : handleSave,
    validate: validate
  }, function (subFormikBag) {
    var typeSelection = subFormikBag.values.type;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, {
      className: _style["default"].subForm
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _get2["default"])(subFormikBag, 'values.type') === 'placeholder' ? _style["default"].placeholderSelected : ''
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "type"
    }, function (fieldProps) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdSelect, _extends({}, fieldProps, {
        label: "Type",
        onChange: function onChange(event) {
          // when selecting bookmark, 'always' is no longer a visibility option
          if (event.target.value === 'bookmark') {
            setIsAdvancedExpanded(false);
            if (fieldProps.form.values.visibility === 'always') {
              fieldProps.form.setFieldValue('visibility', 'disabled');
            }
            fieldProps.form.setFieldValue('unlockAfter', 'entity');
          }

          // when changing from bookmark to something else
          if (event.target.value !== 'bookmark' && fieldProps.form.values.type === 'bookmark') {
            fieldProps.form.setFieldValue('visibility', 'always');
          }
          fieldProps.field.onChange(event);
        },
        options: [{
          value: 'placeholder',
          label: '-- Select type of content --',
          disabled: true
        }].concat(_toConsumableArray(Object.keys(_index.pinnedContentTypeOptions).map(function (k) {
          return {
            value: k,
            label: _index.pinnedContentTypeOptions[k]
          };
        })))
      }));
    })), typeSelection === 'bookmark' && renderBookmarkFields(subFormikBag), typeSelection === 'link' && renderLinkFields(subFormikBag), typeSelection === 'resource' && renderResourceFields(subFormikBag), typeSelection === 'wysiwyg' && renderWysiwygFields(subFormikBag), /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-primary ' + _style["default"].saveButton,
      onClick: subFormikBag.handleSubmit,
      type: "button"
    }, "Save"));
  });
};
var _default = exports["default"] = PinnedContentForm;